interface TagConfig {
  id: string
  label: string
  color: string
}

class Tag {
  public readonly id: string
  public readonly label: string
  public readonly color: string

  constructor(configuration: TagConfig) {
    this.id = configuration.id
    this.label = configuration.label
    this.color = configuration.color
  }
}

export { Tag }
